(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52563],{

/***/ 70235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace/invoices",
      function () {
        return __webpack_require__(7256);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ My_Account; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constant_check_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44902);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60538);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_workspaces_PlansPanel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22092);
/* harmony import */ var _layouts_WorkspaceLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23274);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_workspaces_Plans_BlingHIstory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);











var __N_SSP = true;
function My_Account(param) {
    var isLoggedIn = param.isLoggedIn;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(null), billing_details = ref[0], setBilling_details = ref[1];
    // effect
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if ((0,constant_functions__WEBPACK_IMPORTED_MODULE_3__.getAuthKey)() !== undefined) {
            //
            axios__WEBPACK_IMPORTED_MODULE_10___default().get("/api/v2/invoices", {}).then(function(res) {
                return setBilling_details(res.data);
            }).catch(function(err) {
                return console.log(err);
            });
        } else {
            router.push("/signin?to=".concat(constant_url__WEBPACK_IMPORTED_MODULE_7__.site_url).concat(router.asPath));
        }
    }, [
        router
    ]);
    return (0,constant_check_auth__WEBPACK_IMPORTED_MODULE_2__/* .check_login */ .f)(router, true) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_WorkspaceLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        isLoggedIn: isLoggedIn,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE. "
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE. "
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly – Invoices "
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-grow",
                children: (billing_details === null || billing_details === void 0 ? void 0 : billing_details.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "p-6 space-y-6 ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_workspaces_Plans_BlingHIstory__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        billing_details: billing_details
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full mt-0 p-6 space-y-6 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl text-gray-800 font-bold mb-4",
                            children: "Billing History"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: " pt-20 max-w-[500px] flex flex-col justify-center items-center mx-auto space-y-5 text-center ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    className: "text-2xl font-semibold text-black",
                                    children: "No Invoices Available"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Currently, there are no invoices to display. Invoices will be generated after you subscribe and make a payment. Please check back later or contact support if you have any questions."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,87536,26281,26601,9101,48777,433,23274,22092,49774,92888,40179], function() { return __webpack_exec__(70235); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);